import {Navigate, Outlet, useLocation} from "react-router-dom";
import React from "react";
import useAuth from "../hooks/useAuth";

const AuthLayout = () => {

    const { isAuthenticated, setAuth } = useAuth();
    const location = useLocation();
    const from = location.state?.from?.pathname || '/cabinet'
    return (
        isAuthenticated ?
            <Navigate to={from} state={location} replace/>
            : <div className="min-h-100vh flex grow bg-slate-50 dark:bg-navy-900">
        <main className="grid w-full grow grid-cols-1 place-items-center">
            <Outlet/>
        </main>
    </div>
    );

}

export default AuthLayout;
